export const getSrcSet = (imageSources) => {
  return imageSources.src.map((src, idx) => {
    return {
      src,
      resolution: `${idx + 1}x`,
    };
  });
};

export const getShopifyImageFilePath = (imageSrc) => {
  // Cut out Shopify CDN so we can use Imgix with the Shopify path
  return imageSrc.replace("https://cdn.shopify.com/", "");
};

const image = {
  getSrcSet,
  getShopifyImageFilePath,
};

export default image;
